import React, { useEffect, useState } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { ClientTable } from "./ClientTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchAll,
} from "./clientSlice";
import { useParams } from "react-router-dom";

export const ClientPage = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  // Filter
  const [retNumber, setRetNumber] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [customerName, setCustomerName] = useState("");

  const { id } = useParams();

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  useEffect(() => {
    if (id != null) {
      dispatch(
        fetchAll({
          stepCode: "CLIENT",
          retNumber: id,
          pageNo: pageNo,
          pageSize: pageSize,
        })
      );
    }
  }, [id]);

  const handleSearch = () => {
    const params = {
      stepCode: "CLIENT",
      retNumber: retNumber.replace(/\s/g, ''),
      invoiceNo: invoiceNo,
      customerName: customerName,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    dispatch(fetchAll(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      stepCode: "CLIENT",
      retNumber: retNumber.replace(/\s/g, ''),
      invoiceNo: invoiceNo,
      customerName: customerName,
      pageNo: page,
      pageSize: sizePerPage,
    };
    dispatch(fetchAll(params));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Client"></CardHeader>
      <CardBody>
        {/* Filter */}
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>APL Return Number </b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="APL Return Number "
                    onChange={(e) => {
                      setRetNumber(e.target.value);
                    }}
                    value={retNumber}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Invoice Ref Number</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Invoice Ref Number"
                    onChange={(e) => {
                      setInvoiceNo(e.target.value);
                    }}
                    onKeyPress={handleKeyPress}
                    value={invoiceNo}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer Name</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Customer Name"
                    onChange={(e) => {
                      setCustomerName(e.target.value);
                    }}
                    onKeyPress={handleKeyPress}
                    value={customerName}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Button className="btn btn-primary" onClick={handleSearch}>
                  Search
                </Button>
              </Col>
            </Form.Group>
          </Form.Group>
        </Form>

        {/* Table */}
        {data && data.length > 0 && (
          <ClientTable
            data={data}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        )}
      </CardBody>
    </Card>
  );
};
